import { useState } from "react";


/**
 * Custom hook for managing and synchronizing the checkbox state
 * for test suites, individual test cases, and the overall contract.
 */
const useTestSuiteSync = (testSuites) => {
  const [contractChecked, setContractChecked] = useState(false);
  const [checkedSuites, setCheckedSuites] = useState({});
  const [checkedCases, setCheckedCases] = useState({});
  const [collapsedSuites, setCollapsedSuites] = useState({}); 

  /**
   * Synchronize the "checkedSuites" state based on "checkedCases"
   * A suite is considered checked if all its test cases are checked.
   */
  const syncSuiteChecked = () => {
    const updatedSuites = {};
    Object.entries(checkedCases).forEach(([suiteIndex, caseChecks]) => {
      const allChecked = caseChecks.length > 0 && caseChecks.every(Boolean);
      updatedSuites[suiteIndex] = allChecked;
    });
    setCheckedSuites(updatedSuites);
  };


  /**
   * Synchronize the "contractChecked" state based on all suites and test cases
   * The contract is considered checked if all test cases in all suites are checked.
   */
  const syncContractChecked = () => {
    const allCasesChecked = testSuites.every((suite, i) => {
      const cases = checkedCases[i];
      return cases && cases.length === suite.testCases.length && cases.every(Boolean);
    });
    setContractChecked(allCasesChecked);
  };

  return {
    contractChecked,
    setContractChecked,
    checkedSuites,
    setCheckedSuites,
    checkedCases,
    setCheckedCases,
    collapsedSuites,        
    setCollapsedSuites,     
    syncContractChecked,
    syncSuiteChecked,
  };
};

export default useTestSuiteSync;
